export default 'Aides rénovation 2026 — MPR, CEE, éco-PTZ | SEF';
